import { ConfigCotacaoItemFormulario } from './config-cotacao-item-formulario';

/** Formulários dos Itens da Cotação */
export interface ConfigCotacaoItemFormularioIndicador {
    id: number;
    nome: string;
}

export const itemFormularioRafitecFGR133: ConfigCotacaoItemFormularioIndicador = {id: 1, nome: 'Rafitec - FGR 133'};
export const itemFormularioRafitecFGR219: ConfigCotacaoItemFormularioIndicador = {id: 2, nome: 'Rafitec - FGR 219'};
export const itemFormularioRafitecFGR021: ConfigCotacaoItemFormularioIndicador = {id: 3, nome: 'Rafitec - FGR 021'};
export const itemFormularioRafitecFGR295: ConfigCotacaoItemFormularioIndicador = {id: 4, nome: 'Rafitec - FGR 295'};

export const itensFormulariosIndicadores: ConfigCotacaoItemFormularioIndicador[] = [
    itemFormularioRafitecFGR133,
    itemFormularioRafitecFGR219,
    itemFormularioRafitecFGR021,
    itemFormularioRafitecFGR295
];

/** Obtem o indicador do formulário do item da cotação */
export function getItemFormularioIndicador(id: number): ConfigCotacaoItemFormularioIndicador {
    switch (id) {
        case itemFormularioRafitecFGR133.id:
            return itemFormularioRafitecFGR133;
        case itemFormularioRafitecFGR219.id:
            return itemFormularioRafitecFGR219;
        case itemFormularioRafitecFGR021.id:
            return itemFormularioRafitecFGR021;
        case itemFormularioRafitecFGR295.id:
            return itemFormularioRafitecFGR295;
    }
    return null;
}

export function createItensFormulariosCotacao(itensFormularios: ConfigCotacaoItemFormulario[]): ConfigCotacaoItemFormularioIndicador[] {
    if (!itensFormularios) {
        return [];
    }

    const indicadores: ConfigCotacaoItemFormularioIndicador[] = [];
    itensFormularios.forEach(itemFormulario => {
        const indicador = getItemFormularioIndicador(itemFormulario.formulario);
        if (indicador) {
            indicadores.push(indicador);
        }
    });

    return indicadores;
}


/** Verifica se o formulário do item é RafitecFGR133 */
export function isItemFormularioRafitecFGR133(id: number): boolean {
    return id === itemFormularioRafitecFGR133.id;
}

/** Verifica se o formulário do item é RafitecFGR219 */
export function isItemFormularioRafitecFGR219(id: number): boolean {
    return id === itemFormularioRafitecFGR219.id;
}

/** Verifica se o formulário do item é RafitecFGR021 */
export function isItemFormularioRafitecFGR021(id: number): boolean {
    return id === itemFormularioRafitecFGR021.id;
}

/** Verifica se o formulário do item é RafitecFGR295 */
export function isItemFormularioRafitecFGR295(id: number): boolean {
    return id === itemFormularioRafitecFGR295.id;
}


/** Verifica se o formulário do item é algum dos formulários da empresa Rafitec */
export function isItemFormularioRafitec(id: number): boolean {
    return isItemFormularioRafitecFGR133(id) || isItemFormularioRafitecFGR219(id) || isItemFormularioRafitecFGR021(id) || isItemFormularioRafitecFGR295(id);
}
